var map = {
	"./AbruzzoViniWd1200.png": 64704,
	"./AbruzzoViniWd1600.png": 96836,
	"./AbruzzoViniWd2000.png": 36363,
	"./AbruzzoViniWd350.png": 79577,
	"./AbruzzoViniWd3500.png": 33757,
	"./AbruzzoViniWd500.png": 69636,
	"./AbruzzoViniWd800.png": 41465,
	"./AquilaStemmaW265.png": 50297,
	"./ChietiStemmaW265.png": 12982,
	"./PescaraStemmaW265.png": 51291,
	"./TeramoStemmaW265.png": 34002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45993;